import React from 'react';
import { useSettings } from '../../context/SettingsContext';

const DeferredPageText = ({
  children,
  as: Tag = 'span',
  className = '',
  skeletonClassName = 'text-skeleton'
}) => {
  const { loading } = useSettings();

  if (loading) {
    return (
      <Tag
        className={[skeletonClassName, className].filter(Boolean).join(' ')}
        aria-busy="true"
      />
    );
  }

  return <Tag className={className}>{children}</Tag>;
};

export default DeferredPageText;
